export const validateErrorsState = {
    methods: {
        getErrorMessage(key) {
            if (this.errors && this.errors[key])
                return this.errors[key];

            return "";
        },
        isValidField(key) {
            if (this.errors && this.errors[key])
                return this.errors[key] ? false : true;

            return false;
        },
    }
};